import React, { useMemo, useState } from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import IntroContent from '../../../components/common/introContent';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { applicationStore } from '../../../store/applicationStore';

const IntroContentWrapper = observer(() => {
  const { canvasTranslationKeys } = applicationStore;
  const [introCheckboxState, setIntroCheckboxState] = useState(false);
  const { check, checkbox, button } = useMemo(() => {
    return getGameImages();
  }, []);
  return (
    <Container name='IntroContentWrapper'>
      <IntroContent
        canvasTranslationKeys={canvasTranslationKeys}
        check={check}
        button={button}
        checkbox={checkbox}
        introCheckboxState={introCheckboxState}
        setIntroCheckboxState={setIntroCheckboxState}
      />
    </Container>
  );
});

export default IntroContentWrapper;
